import { render, staticRenderFns } from "./User_Start.vue?vue&type=template&id=5088ba90&scoped=true&"
import script from "./User_Start.vue?vue&type=script&lang=js&"
export * from "./User_Start.vue?vue&type=script&lang=js&"
import style0 from "./User_Start.vue?vue&type=style&index=0&id=5088ba90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088ba90",
  null
  
)

export default component.exports